import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { NGaugeService } from '../../services/shared/ngauge.service';

@Component({
  selector: 'app-filter-dialog-modal',
  templateUrl: './filter-dialog-modal.component.html',
  styleUrls: ['./filter-dialog-modal.component.scss']
})

export class FilterDialogModalComponent implements OnDestroy {

  filterForm: FormGroup;
  formCreated = false;

  constructor(
    private ngaugeService: NGaugeService,
    public dialogRef: MatDialogRef<FilterDialogModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.buildDynamicFilterForm();
  }

  buildDynamicFilterForm() {
    this.filterForm = new FormGroup({});
    const validator: ValidatorFn[] = [];
    this.data['formFields'].forEach((value) => {
      if (value.valids.length > 0) {
        value.valids.forEach((val) => {
          validator.push(Validators[val.valid]);
        });
      }
      if (value['input'] === 'dropdown') {
        value['formControl'] = new FormControl();
        value['filteredDropDownValue'] = new ReplaySubject<any[]>(1);
        this.ngaugeService.buildFilter(value['formControl'], value['filteredDropDownValue'], value['arrayData'], '');
      }
      this.filterForm.addControl(value.key, new FormControl(null, validator));
    });
    this.formCreated = true;
  }

  blockAlpha(event) {
    this.ngaugeService._keyPress(event);
  }

  onClickConfirm(formValues) {
    this.dialogRef.close(formValues);
  }

  onClickCancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.ngaugeService = null;
    this.data = null;
    this.filterForm = null;
    this.dialogRef = null;
    this.formCreated = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/filter-dialog-modal/filter-dialog-modal.component.ts